import 'reflect-metadata';
import { Expose, Transform } from 'class-transformer';
import { LengthValueMillimeter } from './LengthValueMillimeter';
import { Length } from './Length';
import { LengthType } from './LengthType';
import { ELengthValueType } from './ELengthValueType';

export abstract class LengthValue extends Length {
    private _value: number;

    constructor(value: number) {
        super();
        this._value = value;
    }



    @Expose()
    get lengthType(): LengthType {
        return LengthType.LengthValue;
    }

    abstract get type(): ELengthValueType;

    abstract get millimeter(): number;

    abstract get centimeter(): number;

    abstract get meter(): number;

    @Expose()
    get value(): number {
        return this.millimeter;
    }

    toString(): string {
        return this.millimeter.toString();
    }

    
}

export default LengthValue;
